module.exports = __webpack_public_path__ + "static/media/sgd-14.b74eddb5.png";